import { default as Vue } from "vue";
import { default as VueCookies } from "vue-cookies";

Vue.use(VueCookies);
